// extracted by mini-css-extract-plugin
module.exports = {"innSelectorDetails":"inn-selector__details-d84"};